import React, { useEffect, useState } from "react";
import Loader from "react-loader-spinner";
import { Col, Row, Container, Button } from "reactstrap";
import swal from "@sweetalert/with-react";
import Modal from "react-bootstrap/Modal";

var username = localStorage.getItem("firstName");

const PermissionModal = (props) => {
  var data = props.data;
  const {moduleName}= props;
  console.log('moduleName :>> ', moduleName);
  let modulesName = moduleName  ? moduleName : "This Module"
  const [show, setShow] = useState({
    modalShow: true,
  });
  const handleClose = () =>
    setShow({
      modalShow: false,
    });
  return (
    
    
    <Modal
      show={show.modalShow}
      size="md"
      onHide={handleClose}
      on
    >
      <Modal.Header closeButton  className="bg-white border-bottom-0 pb-0 mx-auto  ">
        <div className="d-flex flex-row justify-content-center my-4">
        <div className="rounded-pill shadow  ">
          
        <i className="fa fa-times fa-5x px-4 py-3  text-danger  " ></i>
        </div>
          
        </div>
       
      </Modal.Header>
      <Modal.Body>
      <div className="text-center">
      <h2>Access Denied!</h2>
     
      <h5 className="mt-3">
        
     <strong className="text-danger">
     Role:{' '}
     {modulesName}
     </strong>
        {' '}Not assigned to <strong className="text-danger">User:{' '} {username}</strong>
      </h5> 
      <Button
                    color="primary"
                    className="col-sm-2 mt-4 mr-2 float-right"
                    onClick={handleClose}
                  >
                    {" "}
                    OK
                  </Button>
      </div>
      </Modal.Body>
    </Modal>
  );
};

export default PermissionModal;
